import globals from '#utilities/js/ea/globals.js'
import href from '#utilities/js/ea/href.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import mouseUp from '@mailobj-browser/front/js/events/types/mouseUp.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const id = 'div_IN_PREVIEW'

//@todo fb Ce contract est temporaire, il doit être supprimé lorsqu'on utilisera plus l'ancienne page lecture
const onClick = object(listener, {
  capture,
  type: mouseUp,
  hooks: array([
    preventDefault
  ]),
  task: async (button) => {
    const { value } = button
    const { params } = scope(button)
    const url = href('mail/req_msg', {
      pref_beta: value,
      ...params
    })

    globals.ea_link(url, id, null)
  }
})

export default form => {
  onClick.listen(form)
}
